  document.addEventListener("DOMContentLoaded", function() {
    const button = document.getElementById("cstm_tax_content_chng_rp");
    const content = document.getElementById("taxContentt");

    document.addEventListener("click", function(e) {
      if (e.target === button) {
        content.textContent = "Tax included, Free Shipping.";
      } 
      else {
        content.textContent = "Tax and Shipping Included.";
      }
    });
  });




// document.addEventListener("DOMContentLoaded", function () {

//   const targetProductId = 9282461040863;

//   function updateButton() {

//     if (typeof meta !== "undefined" && meta.product && meta.product.id == targetProductId) {

//       const atcButton = document.querySelector('button[name="add"]');

//       if (atcButton) {

//         // Disable button
//         atcButton.disabled = true;
//         atcButton.style.pointerEvents = "none";
//         // atcButton.style.opacity = "0.6";

//         // FORCE change full button content
//         atcButton.innerHTML = "Coming Soon";
//       }
//     }
//   }

//   // Run immediately
//   updateButton();

//   // Run again after small delay (theme JS override fix)
//   setTimeout(updateButton, 500);

// });




// document.addEventListener("DOMContentLoaded", function () {

//   const targetProductIds = [
//     9458006786271,
//     9458004590815,
//     9457976836319,
//     9457959108831,
//     9453778305247,
//     9463402725599,
//     9463402823903,
//     9463404265695,
//     9463404757215,
//     9463405445343
//   ];

//   function updateButton() {

//     if (
//       typeof meta !== "undefined" &&
//       meta.product &&
//       targetProductIds.includes(meta.product.id)
//     ) {

//       const atcButton = document.querySelector('button[name="add"]');

//       if (atcButton) {
//         // Disable button
//         atcButton.disabled = true;
//         atcButton.style.pointerEvents = "none";

//         // Change button text
//         atcButton.innerHTML = "Coming Soon";
//       }
//     }
//   }

//   // Run immediately
//   updateButton();

//   // Run again after small delay (theme JS override fix)
//   setTimeout(updateButton, 500);

// });




// document.addEventListener("DOMContentLoaded", function () {
//   var productId = 9282461040863;

//   if (window.meta && window.meta.product && window.meta.product.id == productId) {

//     function hideReview() {
//       var reviewWrapper = document.querySelector("#noreviews-wrapper");
//       if (reviewWrapper) {
//         reviewWrapper.style.display = "none";
//         return;
//       }
//       setTimeout(hideReview, 300);
//     }

//     hideReview();
//   }
// });

// document.addEventListener("DOMContentLoaded", function () {
//   var productId = 9295773335775;

//   if (window.meta && window.meta.product && window.meta.product.id == productId) {

//     function hideReview() {
//       var reviewWrapper = document.querySelector("#noreviews-wrapper");
//       if (reviewWrapper) {
//         reviewWrapper.style.display = "none";
//         return;
//       }
//       setTimeout(hideReview, 300);
//     }

//     hideReview();
//   }
// });



// document.addEventListener("DOMContentLoaded", function () {
//   const products = document.querySelectorAll(".t4s-product");

//   products.forEach(function(product){
//     const data = product.getAttribute("data-product-options");
//     if(!data) return;

//     const parsed = JSON.parse(data);

//     if(parsed.VariantFirstID == 48512481689823){
//       product.style.display = "none";
//     }
//   });
// });



// document.addEventListener("DOMContentLoaded", function () {
//   const products = document.querySelectorAll(".t4s-product");

//   products.forEach(function(product){
//     const data = product.getAttribute("data-product-options");
//     if(!data) return;

//     const parsed = JSON.parse(data);

//     if(parsed.VariantFirstID == 48580831051999){
//       product.style.display = "none";
//     }
//   });
// });



// document.addEventListener("DOMContentLoaded", function () {
//     const targetIDs = ["9053736141023", "9053736042719"];
//     const heading = document.querySelector("h3.t4s-section-title.testim-head-rp.t4s-title");

//     function getProductId() {
//         // Try Shopify meta object
//         if (window.meta && window.meta.product && window.meta.product.id) {
//             return String(window.meta.product.id);
//         }

//         // Fallback: check URL for product ID
//         const match = window.location.href.match(/(\d{10,})/);
//         return match ? match[0] : null;
//     }

//     const productId = getProductId();

//     if (targetIDs.includes(productId)) {
//         if (heading) {
//             heading.style.setProperty("display", "none", "important");
//         }
//     }
// });



(function () {
  var NEW_TEXT = 'Coming Soon';

  var style = document.createElement('style');
  style.textContent =
    '[data-coming-soon="true"]{' +
      'pointer-events:none !important;' +
      'opacity:0.6 !important;' +
      'cursor:not-allowed !important;' +
    '}';
  document.head.appendChild(style);

  function isPreorderText(text) {
    text = text.replace(/\s+/g, ' ').trim().toLowerCase();
    return text.indexOf('pre-order') !== -1 || text.indexOf('pre order') !== -1 || text.indexOf('preorder') !== -1;
  }

  function updateButtons() {
    var buttons = document.querySelectorAll(
      '.t4s-product-form__buttons button, .t4s-product-form__buttons a'
    );

    buttons.forEach(function (btn) {
      if (btn.classList.contains('t4s-pr__notify-stock')) return;

      var text = btn.textContent || '';

      if (isPreorderText(text)) {
        var changed = false;
        btn.childNodes.forEach(function (node) {
          if (node.nodeType === 3 && node.nodeValue.trim() !== '') {
            node.nodeValue = NEW_TEXT;
            changed = true;
          }
        });
        if (!changed) {
          var span = btn.querySelector('span');
          if (span) span.textContent = NEW_TEXT;
        }

        btn.style.setProperty('pointer-events', 'none', 'important');
        btn.setAttribute('aria-disabled', 'true');
        btn.setAttribute('tabindex', '-1');
        btn.setAttribute('data-coming-soon', 'true');
        if (btn.tagName === 'BUTTON') btn.disabled = true;

      } else if (btn.getAttribute('data-coming-soon') === 'true' && !isPreorderText(text) && text.trim().toLowerCase().indexOf('coming soon') === -1) {
        btn.style.removeProperty('pointer-events');
        btn.removeAttribute('aria-disabled');
        btn.removeAttribute('tabindex');
        btn.removeAttribute('data-coming-soon');
        if (btn.tagName === 'BUTTON') btn.disabled = false;
      }
    });
  }

  ['click', 'keydown'].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      if (evt === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
      var btn = e.target.closest && e.target.closest('[data-coming-soon="true"]');
      if (btn) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.querySelector && form.querySelector('[data-coming-soon="true"]')) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);

  document.addEventListener('DOMContentLoaded', updateButtons);
  updateButtons();

  var observer = new MutationObserver(function () {
    observer.disconnect();
    updateButtons();
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  });
  observer.observe(document.body, { childList: true, subtree: true, characterData: true });
})();
